import { IQuoteSection, ITradeType, ITransportTypeMenu } from 'types/quote'
import { useEffect, useState } from 'react'
import InfoArea from './InfoArea'
import { tradeTypeMenu, transportTypeMenu } from 'data/quote'

const First = ({ quoteInfo }: IQuoteSection) => {
    const [tradeType, setTradeType] = useState<ITradeType>({} as ITradeType)
    const [transportType, setTransportType] = useState<ITransportTypeMenu>({} as ITransportTypeMenu)

    useEffect(() => {
        const trade = tradeTypeMenu.filter(arr => arr.value === quoteInfo.step1?.tradeType)
        setTradeType(trade[0])
        const transport = transportTypeMenu.filter(arr => arr.value === quoteInfo?.step1?.transportType)
        setTransportType(transport[0])
    }, [quoteInfo])

    return (
        <>
            <div className='font-semibold text-3xl'>
                <p>견적내역</p>
            </div>

            <div className='font-semibold tablet:text-lg text-xl'>
                <p>견적 등록은 하단의 <span className='text-primary'>[작성 완료]</span> 버튼을 눌러야 최종 제출됩니다. </p>
                <p>입력을 모두 마치셨다면 페이지 하단의 ‘작성 완료’ 버튼을 꼭 눌러주세요!</p>
            </div>

            <div className='bg-white border-[#9D9EB7] border-1 rounded-lg'>
                <div className='bg-[#F8F8FA] px-10 py-6 rounded-t-lg'>
                    <p className='font-semibold text-2xl'>구간정보</p>
                </div>

                <div className='flex flex-col gap-6 px-10 py-6'>
                    <div className='flex items-center'>
                        <p className='w-[170px] text-lg'>구분</p>
                        <div className='flex items-center rounded w-[120px]'>
                            <div
                                className={`flex-1 py-3 rounded text-center border-1 transition-all
                                text-primary border-primary`}
                            >
                                {tradeType?.label}
                            </div>
                        </div>
                    </div>

                    <div className='flex items-center'>
                        <p className='w-[170px] text-lg'>운송</p>
                        <div className='flex items-center rounded w-[120px]'>
                            <div
                                className={`flex-1 flex items-center justify-center gap-1 py-3 rounded text-center border-1 transition-all text-primary border-primary`}>
                                {
                                    transportType?.icon &&
                                    <transportType.icon fill={'#196BFF'} />
                                }
                                {transportType?.label}
                            </div>
                        </div>
                    </div>

                    <InfoArea
                        title='출발지'
                        value={`${quoteInfo.step1?.originCode} | ${quoteInfo.step1?.originAddress}`}
                    />
                    <InfoArea
                        title='도착지'
                        value={`${quoteInfo.step1?.destinationCode} | ${quoteInfo.step1?.destinationAddress}`}
                    />
                </div>
            </div >
        </>
    )
}

export default First